/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.analytics.rpc.LeadGenerationRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './LeadGenerationRpc';
import * as Queries from './LeadGenerationRpc.dfc.new';
import type { AdditionalContextArgs } from './LeadGenerationRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;

type UseCreateLeadContactMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.CreateLeadContactResponseType>,
    References.CreateLeadContactRequestType,
    T extends true
      ? Record<'createLeadContact', References.CreateLeadContactResponseType>
      : References.CreateLeadContactResponseType
  >;

export function useCreateLeadContactMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CreateLeadContactResponseType>,
    References.CreateLeadContactRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCreateLeadContactMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CREATE_LEAD_CONTACT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            createLeadContact: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCreateLeadContactMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCreateLeadContactMutationReturn<T>;
}
